import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import moment from "moment";
import { useSnackbar } from "notistack";
import Slide from "@material-ui/core/Slide";
import LinearProgress from "@material-ui/core/LinearProgress";
import Alert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import flag_bd4 from "../assets/images/flag_bd4.png";
import flag_usa4 from "../assets/images/flag_usa4.png";
import transferMoneyIcon_2x from "../assets/images/transferMoneyIcon_2x.png";
import cashdelivery4_2x from "../assets/images/cashdelivery4_2x.png";
import IconSearch13 from "../assets/images/IconSearch13.png";
import Button from "@material-ui/core/Button";
import InputBase from "@material-ui/core/InputBase";
import { Link, useHistory } from "react-router-dom";
import RefreshToken from "../components/RefreshToken";
import { AuthContext } from "../context/AuthContext";
import { TransferContext } from "../context/TransferContext";
import transitions from "@material-ui/core/styles/transitions";

const useStyles = makeStyles((theme) => ({
  paperStyle: {
    padding: theme.spacing(3),
    background: "white",
    // height: "330px",
    borderRadius: "5px",
    boxShadow: "0px 0px 2px 1px rgba(0, 0, 0, .05)",
  },
  paperStyle2: {
    padding: theme.spacing(3),
    background: "white",
    // height: "290px",
    borderRadius: "5px",
    boxShadow: "0px 0px 2px 1px rgba(0, 0, 0, .05)",
  },
  formControl: {
    // margin: theme.spacing(1),
    // minWidth: 120,
    // height:'50px'
  },
  marginBottomStyle: {
    marginBottom: "10px",
  },
  containerStyle: {
    border: "2px solid rgba(156, 56, 54, 0.3)",
    padding: "0px 15px 0px 0px",
    borderRadius: "5px",
    marginBottom: "20px",
  },
  containerStyle2: {
    border: "2px solid #ddd",
    padding: "0px 15px 0px 0px",
    borderRadius: "5px",
    marginBottom: "10px",
  },
  checkContainerStyle: {
    marginTop: 10,
    padding: "10px 15px 0 5px",
  },
  checkContainerStyle2: {
    marginTop: 11,
    padding: "10px 15px 0 5px",
  },
  searchIconStyle: {
    display: "block",
    margin: "10px auto",
  },
  searchIconDivStyle: {
    "&:hover": {
      cursor: "pointer",
    },
  },
  rightAlign: {
    textAlign: "right",
  },

  imageDivStyle: {
    marginRight: "10px",
    padding: "10px 0",
    width: 40,
    boxShadow: "0px 0px 2px 1px rgba(0, 0, 0, .05)",
  },
  imageStyle: {
    display: "block",
    margin: "auto",
  },
  marginTop20: {
    marginTop: "20px",
  },
  marginTop10: {
    marginTop: "10px",
  },
  marginBottom10: {
    marginBottom: "10px",
  },
  greenColor: {
    color: "#35B522",
  },
  redColor: {
    color: "#FA3E3E",
  },
  muteColor: {
    color: "#19181666",
  },
  selectStyle: {
    background: "#FAFAFC",
    textAlign: "left",

    "& img": {
      position: "relative",
      top: "2px",
      marginRight: "5px",
    },
  },
  selectItemStyle: {
    fontWeight: 600,
  },
  buttonStyle: {
    padding: "10px 32px",
    fontSize: "16px",
    color: "white",
    fontWeight: 600,
    textTransform: "capitalize",
    borderRadius: "8px",
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
    },
  },
  field_wrapper: {
    marginTop: 30,
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#9c3836",
      borderWidth: 0,
    },
    "& .MuiInputLabel-root": {
      fontSize: "1.2rem",
      marginTop: -7,
    },
    "& .MuiOutlinedInput-input": {
      padding: "12px 14px",
      fontSize: "1.2rem",
    },
  },
  select: {
    "& .MuiSelect-select:focus": {
      backgroundColor: "#fff",
      borderWidth: 0,
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#fff",
    },
    // padding: "5px",
    height: 35,
    borderRadius: 8,
  },
  flag: {
    marginRight: 10,
    width: 20,
    position: "relative",
    top: 4,
  },
  test: {
    background: "#eee",
    border: "0px solid green",
  },
  dropdownStyle: {
    border: "0px solid black",
    borderRadius: "5%",
    backgroundColor: "#F3F3F3",
  },
  dropdown: {
    border: "1px solid #F3F3F3",
    borderRadius: "5%",
    backgroundColor: "#F3F3F3",
    padding: 4,
  },
  inputRoot: {
    "& .MuiOutlinedInput-input": {
      // color: "green",
      fontWeight: 600,
    },
    "& .MuiInputLabel-root": {
      // color: "green",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#eee",
      // backgroundColor: "#eee",
      color: "#333",
    },
    "&:hover .MuiOutlinedInput-input": {
      // color: "red",
    },
    "&:hover .MuiInputLabel-root": {
      // color: "red",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      // borderColor: "red",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
      // color: "purple",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      // color: "purple",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      // borderColor: "purple",
    },
  },
  nakedInputStyle: {
    "& .MuiInputBase-input": {
      fontSize: "20px",
    },
  },
}));

const Home = () => {
  const classes = useStyles();
  let history = useHistory();
  const [check, setCheck] = useState(false);

  const [countries, setCountries] = useState([]);
  const [receiveCountries, setReceiveCountries] = useState([]);
  const [sendCurrency, setSendCurrency] = useState("USD");
  const [receiveCurrency, setReceiveCurrency] = useState("USD");
  const [receivable, setReceivable] = useState([]);
  const [sendAmount, setSendAmount] = useState(0);
  const [receiveAmount, setReceiveAmount] = useState(0);

  const [transactions, setTransactions] = useState([]);

  const [toCountry, setToCountry] = useState({});
  const [fromCountry, setFromCountry] = useState({});

  const [banks, setBanks] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(false);

  const [transactionNumber, setTransactionNumber] = useState("");
  const [originCountry, setOriginCountry] = useState("");
  const [checkData, setCheckData] = useState({});

  const { login, glob_pay_agent_auth, logout } = useContext(AuthContext);
  const { transfer, addToTransfer, removeTransfer } =
    useContext(TransferContext);

  const { enqueueSnackbar } = useSnackbar();

  const getCountries = async () => {
    setLoading(true);
    try {
      let res = await axios({
        url: "/api/v1/public/countries",
        method: "get",
      });

      setCountries(res.data.data);

      let from = res.data.data.filter((e) => e.currency === sendCurrency);
      setFromCountry(...from);
      setToCountry(...from);

      console.log("ccc", res.data.data);
    } catch (error) {
      console.log("err", error.response);
    }
    setLoading(false);
  };

  const getDocument = async () => {
    setLoading(true);

    let token = await RefreshToken(glob_pay_agent_auth, logout, login);

    try {
      let res = await axios({
        url: "/api/v1/private/document",
        method: "get",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setDocuments(res.data.data);

      console.log("document", res.data.data);
    } catch (error) {
      console.log("err", error.response);
    }
    setLoading(false);
  };

  const getTransaction = async () => {
    setLoading(true);
    let token = await RefreshToken(glob_pay_agent_auth, logout, login);

    try {
      let res = await axios({
        url: `/api/v1/private/agent/transaction?page=0`,
        method: "get",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("Transition", res.data.data);

      setTransactions(res.data.data.content);
    } catch (error) {
      console.log("err:::", error.response);
    }
    setLoading(false);
  };

  const handleSendCurrency = async (event) => {
    let curr = event.target.value;
    setSendCurrency(curr);
    let token = await RefreshToken(glob_pay_agent_auth, logout, login);

    let from = countries.filter((e) => e.currency === curr);
    console.log("from", curr, ...from);
    setFromCountry(...from);

    try {
      let amount = await axios({
        url: `/api/v1/private/currency/${curr}/all`,
        method: "get",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log(amount.data.data.rates);
      setReceivable(amount.data.data.rates);
      console.log(amount.data.data.rates);
    } catch (error) {}
  };

  const handleReceiveCurrency = async (event) => {
    setLoading(true);

    let curr = event.target.value;
    setReceiveCurrency(curr);
    let token = await RefreshToken(glob_pay_agent_auth, logout, login);

    let to = countries.filter((e) => e.currency === curr);
    console.log("to", curr, ...to);

    setToCountry(...to);

    try {
      let amount = await axios({
        url: `/api/v1/private/currency/${sendCurrency}/all`,
        method: "get",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log(amount.data.data.rates);
      setReceivable(amount.data.data.rates);
      console.log(amount.data.data.rates);
    } catch (error) {}
    setLoading(false);
  };

  const handleSendAmount = (e) => {
    setSendAmount(e.target.value);
    console.log(
      "none - ",
      sendCurrency,
      receiveCurrency,
      receivable[receiveCurrency],
      parseInt(sendAmount),
      receivable[receiveCurrency] * sendAmount
    );
  };

  const handleTransferMoney = async (e) => {
    e.preventDefault();
    let data = {
      countries: countries,
      fromCurrency: sendCurrency,
      toCurrency: receiveCurrency,
      rate: receivable[receiveCurrency],
      sendAmount: receivable[receiveCurrency] * parseInt(sendAmount),
      amountToTransfer: parseInt(sendAmount),
      banks: banks,
      documents: documents,
      fromCountry,
      toCountry,
    };
    await addToTransfer(data);
    history.push("/transfer-money");
  };

  const handleCheck = async (e) => {
    e.preventDefault();
    setLoading(true);
    let token = await RefreshToken(glob_pay_agent_auth, logout, login);

    let data = {
      transactionNumber,
      originCountry,
    };

    try {
      let res = await axios({
        url: `/api/v1/private/cashout/existence`,
        method: "post",
        data: data,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log("send", res.data.data);

      setCheckData(res.data.data);
      setCheck(true);
    } catch (error) {
      console.log("err:::", error.response);

      let er = error.response && error.response.data.errors.toString();

      enqueueSnackbar(er, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
        TransitionComponent: Slide,
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    removeTransfer({});
    getCountries();
    getDocument();
    getTransaction();
  }, []);

  return (
    <div>
      {loading ? <LinearProgress /> : null}

      <Grid container spacing={3} style={{ display: "flex" }}>
        <Grid item xs={12} sm={6} md={7} style={{ flex: 1 }}>
          <div className={classes.paperStyle}>
            <form onSubmit={handleTransferMoney}>
              <Typography
                variant="h5"
                gutterBottom
                className={classes.marginBottomStyle}
              >
                Currency Converter
              </Typography>
              <Grid
                container
                alignItems="center"
                className={classes.containerStyle}
              >
                <Grid item lg={8}>
                  <TextField
                    className={classes.field_wrapper}
                    id="outlined-basic"
                    label="Amount to send"
                    variant="outlined"
                    value={sendAmount}
                    onChange={handleSendAmount}
                  />
                </Grid>
                <Grid item lg={4} className={classes.rightAlign}>
                  <FormControl variant="outlined" size="small">
                    <TextField
                      className={classes.inputRoot}
                      value={sendCurrency}
                      onChange={handleSendCurrency}
                      variant="outlined"
                      select
                      InputProps={{
                        className: classes.select,
                      }}
                    >
                      {countries.map((e, index) => (
                        <MenuItem
                          key={index}
                          value={e.currency}
                          className={classes.selectItemStyle}
                        >
                          <img src={e.flag} alt="" className={classes.flag} />
                          {e.currency}
                        </MenuItem>
                      ))}
                    </TextField>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid
                container
                alignItems="center"
                className={classes.containerStyle2}
              >
                <Grid item lg={8}>
                  <TextField
                    className={classes.field_wrapper}
                    label="Receiver will get"
                    variant="outlined"
                    defaultValue="0"
                    value={
                      receivable[receiveCurrency] &&
                      receivable[receiveCurrency] * sendAmount
                    }
                    // onChange={e => set(e.target.value)}
                  />
                </Grid>
                <Grid item lg={4} className={classes.rightAlign}>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                    size="small"
                  >
                    <TextField
                      className={classes.inputRoot}
                      value={receiveCurrency}
                      onChange={handleReceiveCurrency}
                      variant="outlined"
                      select
                      InputProps={{
                        className: classes.select,
                      }}
                    >
                      {countries.map((e, index) => (
                        <MenuItem
                          key={index}
                          value={e.currency}
                          className={classes.selectItemStyle}
                        >
                          <img src={e.flag} alt="" className={classes.flag} />
                          {e.currency}
                        </MenuItem>
                      ))}
                    </TextField>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container alignItems="center">
                <Grid item lg={7}>
                  <Typography
                    variant="body2"
                    gutterBottom
                    className={classes.muteColor}
                  >
                    Conversion Rate
                  </Typography>
                  <Typography variant="h6">
                    {receivable[receiveCurrency]}
                  </Typography>
                </Grid>
                <Grid item lg={5} className={classes.rightAlign}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.buttonStyle}
                    disabled={sendAmount < 1}
                  >
                    Transfer Money
                  </Button>
                </Grid>
              </Grid>
            </form>
          </div>
          <div
            className={classes.paperStyle2}
            style={{ marginTop: 24, height: "calc(100% - 353px)" }}
          >
            <Typography
              variant="h5"
              gutterBottom
              className={classes.marginBottomStyle}
            >
              Cash Pickup Eligibility
            </Typography>

            {!check && (
              <form onSubmit={handleCheck}>
                <Grid container spacing={8}>
                  <Grid item xs={6}>
                    <div className={classes.checkContainerStyle}>
                      <TextField
                        className={classes.nakedInputStyle}
                        id="standard-basic"
                        label="Reference Code"
                        required
                        fullWidth
                        value={transactionNumber}
                        onChange={(e) => setTransactionNumber(e.target.value)}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={6}>
                    <div className={classes.checkContainerStyle2}>
                      <Grid container alignItems="center">
                        <Grid item xs={12}>
                          {/* <Typography
                          variant="body2"
                          className={classes.muteColor}
                          >
                          From where
                        </Typography> */}
                          <TextField
                            className={classes.inputRoot}
                            label="From where"
                            value={originCountry}
                            onChange={(e) => setOriginCountry(e.target.value)}
                            // variant="outlined"
                            required
                            fullWidth
                            select
                            InputProps={{
                              className: classes.select,
                            }}
                          >
                            {countries.map((e, index) => (
                              <MenuItem
                                key={index}
                                value={e.name}
                                className={classes.selectItemStyle}
                              >
                                <img
                                  src={e.flag}
                                  alt=""
                                  className={classes.flag}
                                />
                                {e.name}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>
                  <Grid item xs={12} className={`${classes.rightAlign}`}>
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      className={`${classes.buttonStyle} ${classes.marginTop10}`}
                    >
                      Check
                    </Button>
                  </Grid>
                </Grid>
              </form>
            )}
            {check && (
              <Grid container alignItems="center">
                <Grid item lg={8} className={classes.marginBottomStyle}>
                  <Typography
                    variant="body2"
                    gutterBottom
                    className={classes.muteColor}
                  >
                    Reference Code
                  </Typography>
                  <Typography variant="h6">{transactionNumber}</Typography>
                </Grid>
                <Grid item lg={4} className={classes.marginBottomStyle}>
                  <Typography
                    variant="body2"
                    gutterBottom
                    className={classes.muteColor}
                  >
                    Status
                  </Typography>
                  <Typography variant="h6" className={classes.greenColor}>
                    {checkData.status}
                  </Typography>
                </Grid>

                <Grid item lg={8} className={classes.marginBottomStyle}>
                  <Typography
                    variant="body2"
                    gutterBottom
                    className={classes.muteColor}
                  >
                    From
                  </Typography>
                  <Typography variant="h6">
                    {checkData.originCountry}
                  </Typography>
                </Grid>

                <Grid item lg={4} className={classes.marginBottomStyle}>
                  <Typography
                    variant="body2"
                    gutterBottom
                    className={classes.muteColor}
                  >
                    To
                  </Typography>
                  <Typography variant="h6">
                    {checkData.destinationCountry}
                  </Typography>
                </Grid>
                <Grid item lg={12} className={`${classes.rightAlign}`}>
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={checkData.status != "ReadyForWithdrawal"}
                    className={`${classes.buttonStyle} ${classes.marginTop10}`}
                    onClick={() =>
                      history.push({
                        pathname: "/cash-delivery",
                        state: checkData,
                      })
                    }
                  >
                    Deliver Cash
                  </Button>
                </Grid>
              </Grid>
            )}
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={5} style={{ flex: 1 }}>
          <div
            className={classes.paperStyle}
            style={{ overflow: "auto", height: "100%" }}
          >
            <Typography
              variant="subtitle2"
              className={classes.marginBottomStyle}
            >
              Recent Transactions
            </Typography>

            {transactions.map((item, index) => (
              <Grid
                key={index}
                container
                alignItems="center"
                className={classes.marginBottom10}
              >
                <Grid item lg={2}>
                  <div className={classes.imageDivStyle}>
                    <img
                      src={transferMoneyIcon_2x}
                      alt=""
                      height="24px"
                      className={classes.imageStyle}
                    />
                  </div>
                </Grid>
                <Grid item lg={5}>
                  <Typography variant="subtitle1">{item.status}</Typography>
                  <Typography
                    variant="body2"
                    gutterBottom
                    className={classes.muteColor}
                  >
                    {item.originCountry} To {item.destinationCountry}
                  </Typography>
                </Grid>
                <Grid item lg={5} className={classes.rightAlign}>
                  <Typography
                    variant="subtitle1"
                    className={classes.greenColor}
                  >
                    {item.transaction.amountReceivable.toFixed(2)}
                    <span style={{ marginLeft: 5 }}>
                      {item && item.transaction.toCurrency}
                    </span>
                  </Typography>
                  <Typography
                    variant="body2"
                    gutterBottom
                    className={classes.muteColor}
                  >
                    {moment(item.createdAt).format("DD MMM YYYY")}
                  </Typography>
                </Grid>
              </Grid>
            ))}
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default Home;
